export default __webpack_public_path__ + "static/media/live-dealer-games-medal.4d52b08b.svg";